import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  addProductionItemsCart,
  addRemainsItemsCart,
  changeItemQuantity,
  fetchCartSummary,
} from "../../api/thunks";
import { CartSliceState } from "../types";

export const addItemsExtraReducers = (
  builder: ActionReducerMapBuilder<CartSliceState>,
) => {
  builder.addCase(addProductionItemsCart.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });

  builder.addCase(addProductionItemsCart.fulfilled, (state) => {
    state.error = null;
    state.isLoading = false;
  });
  builder.addCase(addProductionItemsCart.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(addRemainsItemsCart.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });

  builder.addCase(addRemainsItemsCart.fulfilled, (state) => {
    state.error = null;
    state.isLoading = false;
  });
  builder.addCase(addRemainsItemsCart.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(changeItemQuantity.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });

  builder.addCase(changeItemQuantity.fulfilled, (state) => {
    state.error = null;
    state.canCreateOrder = true;
    state.isLoading = false;
  });
  builder.addCase(changeItemQuantity.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });
};
